<div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel-onboarding></left-panel-onboarding>
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas h-500">
            <grid-row class="h-100 justify-content-center align-content-between">
                <grid-col col="12">
                    <div class="font-400 font-size-20px line-h-25">
                        {{ "WouldPhysicalCard" | translate }}
                    </div>
                    <grid-row class="mt-50">
                        <grid-col col="12">
                            <div class="custom-radio">
                                <input type="radio" value="Outstanding amount" id="radio-1" name="radioGroup2">
                                <label for="radio-1">
                                    <grid-row class="justify-content-between align-item-center">
                                        <grid-col col="auto">
                                            <div class="font-600 font-size-14px line-h-22">
                                                {{"Yes" | translate}}
                                            </div>
                                        </grid-col>
                                    </grid-row>
                                </label>
                            </div>
                            <div class="custom-radio mt-15">
                                <input type="radio" value="Outstanding amount" id="radio-2" name="radioGroup2">
                                <label for="radio-2">
                                    <grid-row class="justify-content-between align-item-center">
                                        <grid-col col="auto">
                                            <div class="font-600 font-size-14px line-h-22">
                                                {{"NoDigitalCardOnly" | translate}}
                                            </div>
                                        </grid-col>
                                    </grid-row>
                                </label>
                            </div>
                        </grid-col>
                    </grid-row>
                </grid-col>
                <grid-col col="12">
                    <button class="btn-dft" (click)="cardRequestNameAppear()">
                        {{ "NEXT" | translate }}
                    </button>
                    <div class="mt-40">
                        {{ "SuccessScreen" | translate }}
                    </div>
                    <button class="btn-dft" (click)="payCardSuccess()">
                        {{ "NEXT" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>